import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin } from 'rxjs';

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    //const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    // Les notifications ne sont pas chargées ici : le panneau (NotificationsComponent) les charge
    // lui-même avec l'identifiant du compte, sans bloquer l'affichage de l'application.

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
       // quickChatService.getChats(),
        shortcutsService.getAll(),
    ]);
};
